import { h } from 'preact'
import { baseUrl } from '../pmd/pmd-urls'
import styles from './index.module.css'

export function MapOfSomalia() {
  return (
    <figure className={styles.mapOfSomalia}>
      <img
        src={`${baseUrl}rev1/map_route_somalia_2.svg`}
        alt="Kart over reisen fra Hargeisa til Bosaso nord i Somalia. Kartet viser plasseringen av de to byene, sammen med en stiplet reiserute mellom byene."
      />
    </figure>
  )
}
